export default __webpack_public_path__ + "static/media/sutd_logo.ee566a76.png";